import { render, staticRenderFns } from "./weekdays_labels.vue?vue&type=template&id=42b572d6&scoped=true"
import script from "./weekdays_labels.vue?vue&type=script&lang=js"
export * from "./weekdays_labels.vue?vue&type=script&lang=js"
import style0 from "./weekdays_labels.vue?vue&type=style&index=0&id=42b572d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b572d6",
  null
  
)

export default component.exports